<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M11 13.5a2.5 2.5 0 1 0 1.17-2.12 8.8 8.8 0 0 1 .96-2.76 12.06 12.06 0 0 1 2.22-2.77.5.5 0 0 0-.7-.7h-.02c-.74.75-1.66 1.67-2.38 2.98A10.83 10.83 0 0 0 11 13.5Zm-5.83-2.12A2.5 2.5 0 1 1 4 13.5c0-2.33.52-4.04 1.25-5.37a12.97 12.97 0 0 1 2.38-2.97l.02-.01a.5.5 0 1 1 .7.7c-.75.76-1.58 1.59-2.22 2.77a8.8 8.8 0 0 0-.96 2.76Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12.17 11.38a8.8 8.8 0 0 1 .96-2.76 12.06 12.06 0 0 1 2.22-2.77.5.5 0 0 0-.7-.7h-.02c-.74.75-1.66 1.67-2.38 2.98A10.83 10.83 0 0 0 11 13.5a2.5 2.5 0 1 0 1.17-2.12ZM12 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-6.83-2.12a8.8 8.8 0 0 1 .96-2.76 12.06 12.06 0 0 1 2.22-2.77.5.5 0 1 0-.7-.7h-.02c-.74.75-1.66 1.67-2.38 2.98A10.83 10.83 0 0 0 4 13.5a2.5 2.5 0 1 0 1.17-2.12ZM6.5 12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
    />
  </svg>
</template>
